import { createSelector } from 'reselect'

import identitySelector from './identity_selector'

const getInteractiveVideoSession = state => state.interactiveVideoCreation

const sessionInitialization = createSelector(
	[ 	getInteractiveVideoSession,
		identitySelector ],
	(interactiveVideo, interactiveVideoIdentity) => ({
		jwt: interactiveVideoIdentity.jwt,
		uid: interactiveVideoIdentity.uid,
		mediaUid: interactiveVideo.media.uid,
	})
)

export default sessionInitialization
